module.exports = __webpack_public_path__ + "images/icon-hd-d5c26250.png";